// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputContainer_HENyO {
    position : relative;
    width : 100%;
}

.cameraIcon_U8ZFw { 
  }`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/pairing/DeviceInput.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;EACE","sourcesContent":[".inputContainer {\n    position : relative;\n    width : 100%;\n}\n\n.cameraIcon { \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `inputContainer_HENyO`,
	"cameraIcon": `cameraIcon_U8ZFw`
};
export default ___CSS_LOADER_EXPORT___;
